import { render, staticRenderFns } from "./comNat-add.vue?vue&type=template&id=2688f572&scoped=true&"
import script from "./comNat-add.vue?vue&type=script&lang=js&"
export * from "./comNat-add.vue?vue&type=script&lang=js&"
import style0 from "./comNat-add.vue?vue&type=style&index=0&id=2688f572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688f572",
  null
  
)

export default component.exports